import { Submenu } from 'element-ui'

const YSubmenu = Submenu
YSubmenu.$depends = [Submenu]
YSubmenu.$name = 'y-submenu'
YSubmenu._name = 'Submenu 子菜单'

export default YSubmenu
